const SpotifyCredentials = {
  clientId: '3d63f5468e714e0886ab402d206ed5d1',
  clientSecret: '8d9961ff3963410aa076177e063243de',
};

export default SpotifyCredentials;
